/**
 * @generated SignedSource<<e11972ff016f52037080c6e2d1a89148>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveInstallment_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallmentCompleted_query">;
  readonly " $fragmentType": "PaymentActiveInstallment_query";
};
export type PaymentActiveInstallment_query$key = {
  readonly " $data"?: PaymentActiveInstallment_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallment_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveInstallment_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveInstallmentCompleted_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b22b2d4a62c72380eb9d6d60a2f5aaf7";

export default node;
